import { Component, Input } from '@angular/core';
import { FormatacaoConfigForm } from '../../../types/smartinteg';
import { ARREDONDAMENTOS, PADRAO_DESTINO_DATA, PADROES_DATA, TIPOS_CAMPO, destinoDaRegra, ehData, ehNumero, novaRegra } from './formatacao-config.util';

/**
 * Editor de Recurso.configuracoes.formatacoes (regras de formatação de datas e números).
 * Edita o modelo recebido no lugar; quem salva usa montarFormatacao/validarFormatacao do util.
 */
@Component({
  selector: 'app-formatacao-config',
  templateUrl: './formatacao-config.component.html',
  styleUrls: ['./formatacao-config.component.css']
})
export class FormatacaoConfigComponent {

  @Input() model!: FormatacaoConfigForm;

  readonly tipos = TIPOS_CAMPO;
  readonly arredondamentos = ARREDONDAMENTOS;
  readonly padroesData = PADROES_DATA;
  readonly padraoDestino = PADRAO_DESTINO_DATA;

  ehData = ehData;
  ehNumero = ehNumero;
  destinoDaRegra = destinoDaRegra;

  adicionar(): void { this.model.regras.push(novaRegra()); }
  remover(i: number): void { this.model.regras.splice(i, 1); }

  mover(i: number, delta: number): void {
    const j = i + delta;
    if (j < 0 || j >= this.model.regras.length) return;
    const [r] = this.model.regras.splice(i, 1);
    this.model.regras.splice(j, 0, r);
  }
}
